import styled from 'styled-components';
import { SPACING } from '@optimus-web/local-tokens';

export const ContentElement = styled.div`
    display: flex;
    align-items: center;
    & > *:last-child {
        margin-left: ${SPACING[100]}px;
    }
`;
